import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteNewsComponent } from './website-news.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [WebsiteNewsComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WebsiteNewsComponent]
})
export class WebsiteNewsModule { }
